const COOKIE = 'rn_ad';
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
const PAID_MEDIUMS = new Set(['paid_social', 'cpc', 'paid']);
const PAID_SOURCES = new Set(['facebook', 'fb', 'ig', 'instagram', 'meta']);

export function adClickFromSearch(search, { path = '/', seenAt = new Date() } = {}) {
  const raw = String(search || '');
  const params = new URLSearchParams(raw.startsWith('?') ? raw.slice(1) : raw);
  const utmSource = (params.get('utm_source') || '').toLowerCase();
  const utmMedium = (params.get('utm_medium') || '').toLowerCase();
  const fbclid = params.get('fbclid') || '';
  if (!fbclid || !PAID_MEDIUMS.has(utmMedium) || !PAID_SOURCES.has(utmSource)) {
    return null;
  }
  const when = seenAt instanceof Date ? seenAt : new Date(seenAt);
  return {
    fbclid: fbclid.slice(0, 512),
    utmSource,
    utmMedium,
    utmCampaign: params.get('utm_campaign') || '',
    utmContent: params.get('utm_content') || '',
    utmTerm: params.get('utm_term') || '',
    landingPath: path || '/',
    seenAt: when.toISOString(),
  };
}

export function readAdClick() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|; )rn_ad=([^;]*)/);
  if (!match) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(match[1]));
    if (!parsed?.fbclid) return null;
    return parsed;
  } catch {
    return null;
  }
}

function writeAdClick(payload) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${encodeURIComponent(JSON.stringify(payload))}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

/** First paid click in this browser wins. Later ads do not replace it. */
export function captureAdClick() {
  if (typeof window === 'undefined') return null;
  if (readAdClick()) return readAdClick();
  const next = adClickFromSearch(window.location.search, {
    path: window.location.pathname,
  });
  if (!next) return null;
  writeAdClick(next);
  return next;
}
